@if (bannerDataForCurrentClient || client.isCms) {
<href [link]="bannerDataForCurrentClient?.link">
    <countdown [date]="bannerDataForCurrentClient?.time_end"
               [whitelist]="['hours', 'minutes', 'seconds']"
               [shouldPad]="true">
        <ng-template #countdownTemplate
                     let-result>
            @if (result?.score) {
            <div class="w-12 center p-a-1"
                 [style.background-color]="bannerDataForCurrentClient.background_colour || ''">
                <!-- text -->
                <p class="inline-block"
                   [ngClass]="bannerDataForCurrentClient.text_style || ''"
                   [class.fw-bold]="bannerDataForCurrentClient?.bold"
                   [class.underline]="bannerDataForCurrentClient?.underline"
                   [style.color]="bannerDataForCurrentClient.text_colour || ''"
                   *iCms="'text' of bannerDataForCurrentClient">
                </p>&nbsp;
                <!-- date -->
                <span [ngClass]="bannerDataForCurrentClient.text_style || ''"
                      [style.color]="bannerDataForCurrentClient.timer_colour || ''">
                    {{result.score?.hours}}h {{result.score?.minutes}}m {{result.score?.seconds}}s
                </span>
            </div>
            }
            @if (!result?.score && client.isCms) {
            <div class="center p1">{{'Countdown finished' | translate}}</div>
            }
        </ng-template>
    </countdown>
</href>
}
